module.exports = __webpack_public_path__ + "img/phont2.f7c07d5a.png";